// The Cockpit's licence banner (ADR-0008): on an on-prem installation, every Owner sees above every page that its
// licence needs renewing, with the days left before the business becomes read-only and how to renew, or that it has
// lapsed; and that its backups are stale. Nobody else sees it, and a SaaS business never does.
import { useEffect, useState } from "react";
import type { Api, LicenceBanner as Banner } from "../api.js";

/** The licence banner's notices, loaded once for an Owner. */
export function useLicenceBanner(api: Api, owner: boolean): Banner | undefined {
  const [banner, setBanner] = useState<Banner | undefined>(undefined);
  useEffect(() => {
    if (!owner) return;
    let live = true;
    api.licence().then(
      (shown) => live && setBanner(shown),
      () => undefined,
    );
    return () => {
      live = false;
    };
  }, [api, owner]);
  return banner;
}

export function LicenceBanner({ banner }: { banner: Banner | undefined }) {
  if (!banner || banner.notices.length === 0) return null;
  return (
    <div className="licence-banner" role="status" data-state={banner.state}>
      {banner.notices.map((notice) => (
        <p key={notice}>{notice}</p>
      ))}
    </div>
  );
}
